import React from 'react';
import { PopOverWrapper, PopOverContent, PopOverTrigger } from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';

import Classes from './ExperimentPopOver.scss';

const ExperimentPopOver = () => {
  const { t } = useI18nContext();

  return (
    <div className={Classes.container}>
      <PopOverWrapper placement="bottom-start" openOnLoad>
        <PopOverTrigger>
          {/* empty element to not interfer with actions click */}
          <div />
        </PopOverTrigger>

        <PopOverContent>
          <div className={Classes.content}>{t('listing.header.actions.popover')}</div>
        </PopOverContent>
      </PopOverWrapper>
    </div>
  );
};

export default ExperimentPopOver;
